module.exports = __webpack_public_path__ + "static/statesman-bg-39224e2f152206fe995fb11c9db471b3.png";